import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import Button from 'atoms/button';
import { closeDrawer } from 'store/reducers/ui';

export default function NoServices({ reason }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const onCreateService = () => {
    dispatch(closeDrawer());
    navigate('/add-service');
  };

  if (reason === 'no-serviced-animals') {
    return (
      <p className="f13">Please select an animal type before adding services</p>
    );
  } else {
    return (
      <>
        <p className="f13">
          No services offered for cats. Please create a new service, or select a
          different animal.
        </p>
        <Button
          variant="white-outlined"
          size="small"
          text="+ Create service"
          className="fw-400 mt-10"
          onClick={onCreateService}
        />
      </>
    );
  }
}
